import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router';

//MaterialUI Imports
import {
    Alert,
    Autocomplete,
    Box,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    Snackbar,
    Stack,
    TextField,
    Tooltip,
    Typography,
    CardHeader,
    InputLabel,
    Card,
    CardContent,
    FormControl,
    Select,
    MenuItem
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MainCard from 'ui-component/cards/MainCard';

//icon imports
import PaymentsIcon from '@mui/icons-material/Payments';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FunctionsIcon from '@mui/icons-material/Functions';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

//services imports
import useEmployeeService from 'services/useEmployeeService';
import useABMSalarySlabsService from 'services/useABMSalarySlabsService';
import useABMDailyAllowanceService from 'services/useABMDailyAllowanceService';
import useABMFieldExpensesService from 'services/useABMFieldExpensesService';
import UseABMPRisService from 'services/useABMPRIsService';

//project imports
//import TMCard from './TMCard';
//import ABMCard from './ABMCard';
import ROABMSalarySheet from './ROABMSalarySheet';
import useSalariesService from 'services/useSalariesService';

const ROABM = (props) => {
    const { selectedRole, selectedLocation, selectedMonth, selectedYear } = props;
    const theme = useTheme();
    const navigate = useNavigate();

    //states
    const [submitting, setSubmitting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState();
    const [abmSalarySlabDetails, setABMSalarySlabDetails] = useState();
    const [abmFiledExpensesDetails, setABMFiledExpensesDetails] = useState();
    const [abmDailyAllowanceDetails, setABMDailyAllowanceDetails] = useState();
    const [abmPRIsDetails, setABMPRIsDetails] = useState();
    const [salaryReadOnly, setSalaryReadOnly] = useState();
    //services
    const { getEmployees } = useEmployeeService();
    const { getABMSalarySlab } = useABMSalarySlabsService();
    const { getABMDailyAllowanceById } = useABMDailyAllowanceService();
    const { getABMFieldExpenses } = useABMFieldExpensesService();
    const { getABMPRIs } = UseABMPRisService();
    const { getAllSalaries } = useSalariesService();
    //handlers
    const handleGetEmployees = () => {
        getEmployees('', selectedRole, selectedLocation, 0, 100000)
            .then((response) => {
                if (response.status == 200) {
                    setEmployees(response.data.users);
                } else {
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };
    const handleGetSalaryReadOnly = () => {
        getAllSalaries(selectedRole, selectedLocation, selectedMonth, selectedYear)
            .then((response) => {
                console.log('response', selectedRole, selectedLocation, selectedMonth, selectedYear);
                if (response.status == 200) {
                    setSalaryReadOnly(response.data.salaries);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };
    const handleGetSalarySlabs = () => {
        getABMSalarySlab()
            .then((response) => {
                if (response.status == 200) {
                    if (response.data.list.length > 0) {
                        setABMSalarySlabDetails(response.data.list[0]);
                    }
                } else {
                    console.log(response.data);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };
    const handleGetDailyAllowance = () => {
        getABMDailyAllowanceById(abmSalarySlabDetails.id)
            .then((response) => {
                if (response.status == 200) {
                    setABMDailyAllowanceDetails(response.data.abmdAs);
                } else {
                    console.log(response.data);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleGetFieldExpenses = () => {
        getABMFieldExpenses(abmSalarySlabDetails.id)
            .then((response) => {
                if (response.status == 200) {
                    setABMFiledExpensesDetails(response.data.list);
                } else {
                    console.log(response.data);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleGetPRIs = () => {
        getABMPRIs(abmSalarySlabDetails.id)
            .then((response) => {
                if (response.status == 200) {
                    setABMPRIsDetails(response.data.list);
                } else {
                    console.log(response.data);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    //use effects
    useEffect(() => {
        handleGetEmployees();
        handleGetSalarySlabs();
    }, [selectedRole, selectedLocation]);
    useEffect(() => {
        if (abmSalarySlabDetails) {
            handleGetDailyAllowance();
        }
    }, [abmSalarySlabDetails]);
    useEffect(() => {
        if (abmSalarySlabDetails) {
            handleGetFieldExpenses();
        }
    }, [abmSalarySlabDetails]);

    useEffect(() => {
        if (abmSalarySlabDetails) {
            handleGetPRIs();
        }
    }, [abmSalarySlabDetails]);
    useEffect(() => {
        handleGetSalaryReadOnly();
    }, [selectedRole, selectedLocation, selectedMonth, selectedYear]);
    return (
        <Box>
            <Grid container spacing={2}>
                {employees ? (
                    <>
                        {/* {employees.map((employee, index) => {
                            return ( */}
                        <Grid item xs={12} md={12}>
                            <ROABMSalarySheet
                                employee={employees}
                                abmSalarySlabDetails={abmSalarySlabDetails}
                                abmDailyAllowanceDetails={abmDailyAllowanceDetails}
                                abmFiledExpensesDetails={abmFiledExpensesDetails}
                                abmPRIsDetails={abmPRIsDetails}
                                salaryData={salaryReadOnly}
                                onRefresh={() => {
                                    handleGetSalarySlabs();
                                    handleGetDailyAllowance();
                                    handleGetFieldExpenses();
                                    handleGetPRIs();
                                }}
                                location={selectedLocation}
                                month={selectedMonth}
                                year={selectedYear}
                            />
                        </Grid>
                        {/* );
                        })} */}
                    </>
                ) : null}
            </Grid>
        </Box>
    );
};

export default ROABM;
